import configureStore from './configureStore';
import storage from '../libs/storage';

const APP_STORAGE = 'fisherman';

const store = configureStore(storage.get(APP_STORAGE) || {});

export default store;
